import { Expose, Transform, Type } from "class-transformer";
import { PermissionEnum } from "@altertec_gparn/lib";
import { toEuros } from "@/utils/numberUtils";

export class PurchaseApprovalConfigurationDto {
  @Expose()
  permission: PermissionEnum;

  @Expose()
  @Type(() => Number)
  @Transform(({ value }) => toEuros(value))
  minAmount: number;
}
